function isDevEnv() {
    return !!(import.meta.env && import.meta.env.DEV);
}
export const isDev = isDevEnv() || false;
export const Config = {
    debug: false,
    animationsEnabled: true,
    animationSettings: {
        duration: 250,
        easing: 'ease-in-out',
    },
    fontSettings: {
        fontFamily: 'Ubuntu',
        fontSize: 100,
    },
    setActiveElement: () => { },
};
//# sourceMappingURL=config.js.map